// extracted by mini-css-extract-plugin
export default {"NavigationItems":"NavigationItems_NavigationItems__eY4A1","NestedNavigationItem":"NavigationItems_NestedNavigationItem__xpbeE"};